// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"6f7d1a4b","450":"0ae7dc62","787":"939ad0ed","997":"235d3fb4"}[chunkId] + ".chunk.js";
};